import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

const RootView = () => import(/* webpackChunkName: "RootView" */'../components/RootView.vue')
const Home = () => import(/* webpackChunkName: "Home" */'../components/Home.vue')
const PageNotFound = () => import(/* webpackChunkName: "PageNotFound" */'../components/PageNotFound.vue')

const Activity = () => import(/* webpackChunkName: "Activity" */'../components/activity')
const ActivityList = () => import(/* webpackChunkName: "ActivityList" */'../components/activity/ActivityList.vue')
const ActivityDetail = () => import(/* webpackChunkName: "ActivityDetail" */'../components/activity/ActivityDetail.vue')

const AboutUs = () => import(/* webpackChunkName: "AboutUs" */'../components/AboutUs.vue')
const Organization = () => import(/* webpackChunkName: "Organization" */'../components/Organization.vue')

const ActivityPhoto = () => import(/* webpackChunkName: "ActivityPhoto" */'../components/activity_photo')
const ActivityPhotoList = () => import(/* webpackChunkName: "ActivityPhotoList" */'../components/activity_photo/ActivityPhotoList.vue')
const ActivityPhotoDetail = () => import(/* webpackChunkName: "ActivityPhotoDetail" */'../components/activity_photo/ActivityPhotoDetail.vue')

const Literature = () => import(/* webpackChunkName: "Literature" */'../components/literature')
const LiteratureList = () => import(/* webpackChunkName: "LiteratureList" */'../components/literature/LiteratureList.vue')
const LiteratureDetail = () => import(/* webpackChunkName: "LiteratureDetail" */'../components/literature/LiteratureDetail.vue')

const News = () => import(/* webpackChunkName: "News" */'../components/news')
const NewsList = () => import(/* webpackChunkName: "NewsList" */'../components/news/NewsList.vue')
const NewsDetail = () => import(/* webpackChunkName: "NewsDetail" */'../components/news/NewsDetail.vue')

const JoinUs = () => import(/* webpackChunkName: "JoinUs" */'../components/JoinUs.vue')

const UserCenter = () => import(/* webpackChunkName: "UserCenter" */'../components/user/UserCenter.vue')
const UserInfo = () => import(/* webpackChunkName: "UserInfo" */'../components/user/UserInfo.vue')
const UpdatePwd = () => import(/* webpackChunkName: "UpdatePwd" */'../components/user/UpdatePwd.vue')
const MyActivity = () => import(/* webpackChunkName: "MyActivity" */'../components/user/MyActivity.vue')
const MyQuestionCard = () => import(/* webpackChunkName: "MyQuestionCard" */'../components/user/MyQuestionCard.vue')



const Explain = () => import(/* webpackChunkName: "MyActivity" */'../components/Explain.vue')
Vue.use(Router)

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      component: PageNotFound
    },
    {
      path: '/Association/ActivityDetail/:id',
      redirect: to => {
        // 可以在这里添加额外的逻辑
        return { path: `/ActivityDetail/${to.params.id}` }
      }
    },
    {
      path: '/Association/JoinUs',
      redirect: '/JoinUs'
    },
    {
      path: '/',
      component: RootView,
      children: [
        {
          path: '',
          redirect: '/home'
        },
        {
          path: '/home',
          component: Home,
          meta: {
            title: '',
            content: {
              keywords: '香港中醫學會',
              description: '香港中醫學會',
            }
          }
        },
        {
          path: '/ActivityList',
          component: Activity,
          children: [
            {
              path: '',
              component: ActivityList,
              meta: {
                title: '課程及活動',
                content: {
                  keywords: '課程及活動',
                  description: '',
                }
              }
            },
            {
              path: '/ActivityDetail/:id',
              component: ActivityDetail,
              meta: {
                title: '課程及活動',
                content: {
                  keywords: '課程及活動',
                  description: '',
                }
              }
            }
          ]
        },
        {
          path: '/AboutUs',
          component: AboutUs,
          meta: {
            title: '關於我們',
            content: {
              keywords: '關於我們',
              description: '',
            }
          }
        },
        {
          path: '/Organization',
          component: Organization,
          meta: {
            title: '架構及成員',
            content: {
              keywords: '架構及成員',
              description: '',
            }
          }
        },
        {
          path: '/explain',
          component: Explain,
          meta: {
            title: '帳號聲明',
            content: {
              keywords: '帳號聲明',
              description: '',
            }
          }
        },
        {
          path: '/ActivityDetail/:id',
          redirect: to => {
            // 可以在这里添加额外的逻辑
            return { path: `/ActivityDetail/${to.params.id}` }
          }
        },
        {
          path: '/ActivityPhotos',
          redirect: '/ActivityPhotos/list'
        },
        {
          path: '/ActivityPhotos/list',
          component: ActivityPhoto,
          children: [
            {
              path: '',
              component: ActivityPhotoList,
              meta: {
                title: '活動照片',
                content: {
                  keywords: '活動照片, 學會活動照片',
                  description: '',
                }
              }
            },
            {
              path: '/ActivityPhotos/details/:id',
              component: ActivityPhotoDetail,
              meta: {
                title: '活動照片詳情',
                content: {
                  keywords: '活動照片詳情',
                  description: '',
                }
              }
            }
          ]
        },
        {
          path: '/LiteratureList',
          component: Literature,
          children: [
            {
              path: '',
              component: LiteratureList,
              meta: {
                title: '學術及文化',
                content: {
                  keywords: '學術及文化',
                  description: '',
                }
              }
            },
            {
              path: '/LiteratureDetail/:id',
              component: LiteratureDetail,
              meta: {
                title: '學術及文化',
                content: {
                  keywords: '學術及文化',
                  description: '',
                }
              }
            },
          ]
        },
        {
          path: '/JoinUs',
          component: JoinUs,
          meta: {
            title: '加入學會',
            content: {
              keywords: '加入學會',
              description: '',
            }
          }
        },
        {
          path: '/News',
          component: News,
          redirect: '/News/list',
          children: [
            {
              path: '/News/list',
              component: NewsList,
              meta: {
                title: '學會資訊',
                content: {
                  keywords: '學會資訊',
                  description: '',
                }
              }
            },
            {
              path: 'News/details/:id',
              component: NewsDetail,
              meta: {
                title: '學會資訊',
                content: {
                  keywords: '學會資訊',
                  description: '',
                }
              }
            }
          ]
        },{
          path: '/user',
          component: UserCenter,
          children: [
            {
              path: '/user',
              component: UserInfo,
              meta: {
                title: '個人資料 - 個人中心',
                content: {
                  keywords: '個人資料',
                  description: '',
                }
              }
            },
            {
              path: '/user/pwd',
              component: UpdatePwd,
              meta: {
                title: '修改密碼 - 個人中心',
                content: {
                  keywords: '修改密碼',
                  description: '',
                }
              }
            },
            {
              path: '/user/myActivity',
              component: MyActivity,
              meta: {
                title: '我的學會活動課程 - 個人中心',
                content: {
                  keywords: '我的學會活動,學會課程',
                  description: '',
                }
              }
            },
            {
              path: '/user/myQuestionCard',
              component: MyQuestionCard,
              meta: {
                title: '我的問題卡 - 個人中心',
                content: {
                  keywords: '我的問題卡,問題卡,答題卡',
                  description: '',
                }
              }
            },
            
          ]
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
          return savedPosition
      } else {
          return {
              x: 0,
              y: 0
          }
      }
    }
  })
  function setup(to, from, next){
    if(/^\/News\/details\/\d+/.test(to.path)) {
      var _path = to.path.replace('News/details/', '')
      var index = _path.indexOf('/')
      var id = _path.substring(0, index == -1 ? _path.length : index)
      //提前獲取詳情
      store.dispatch('getNewsDetail', {newsid: id}).then((rs)=>{
        if(rs) {
          var news = rs.news
          if(news.title) {
            document.title = `${news.title} - ${document.title}`
            appendMeta(`${news.title},香港中醫學會`, news.introduce)
          }
          sessionStorage.setItem('detail', JSON.stringify(rs))
          next()
        }
      })
    } else if(/^\/ActivityPhotos\/details\/\d+/.test(to.path)) {
      var _path = to.path.replace('/ActivityPhotos/details/', '')
      var index = _path.indexOf('/')
      var id = _path.substring(0, index == -1 ? _path.length : index)
      //提前獲取詳情
      store.dispatch('getActivityPhotoDetail', {id: id}).then((detail)=>{
        if(detail) {
          if(detail.title) {
            document.title = `${detail.title} - ${document.title}`
            appendMeta(`${detail.title},香港中醫學會`, detail.title)
          }
          sessionStorage.setItem('detail', JSON.stringify(detail))
          next()
        }
      })
    } else if(/^\/LiteratureDetail\/\d+/.test(to.path)) {
      var _path = to.path.replace('/LiteratureDetail/', '')
      var index = _path.indexOf('/')
      var id = _path.substring(0, index == -1 ? _path.length : index)
      //提前獲取詳情
      store.dispatch('getArticleDetail', {'articleid': id}).then((detail)=>{
        if(detail) {
          if(detail.title) {
            document.title = `${detail.title} - ${document.title}`
            appendMeta(`${detail.title},香港中醫學會,香港中醫在綫`, detail.introduce)
          }
          sessionStorage.setItem('detail', JSON.stringify(detail))
          next()
        }
      })
    } else if(/^\/ActivityDetail\/\d+/.test(to.path)) {
      var _path = to.path.replace('/ActivityDetail/', '')
      var index = _path.indexOf('/')
      var id = _path.substring(0, index == -1 ? _path.length : index)
      //提前獲取詳情
      store.dispatch('getActivityDetail', {'activityid': id, uid: store.getters.userInfo && store.getters.userInfo.clientid}).then((detail)=>{
        if(detail) {
          if(detail.title) {
            document.title = `${detail.title} - ${document.title}`
            appendMeta(`${detail.title},香港中醫學會,香港中醫在綫`, detail.introduce)
          }
          sessionStorage.setItem('detail', JSON.stringify(detail))
          next()
        }
      })
    } else {
      next()
    }
  }

  
  function appendMeta(keyword, description) {
    if(!keyword && !description) return;
    
    if(keyword) {
      let keywordMeta = document.querySelector('meta[name="keywords"]')
      if(keywordMeta) {
        document.head.removeChild(keywordMeta)
      }
      keywordMeta = document.createElement('meta')
      keywordMeta.setAttribute('name', 'keywords')
      keywordMeta.setAttribute('content', keyword)
      document.head.appendChild(keywordMeta);
    }
    if(description) {
      let descriptionMeta = document.querySelector('meta[name="description"]')
      if(descriptionMeta) {
        document.head.removeChild(descriptionMeta)
      }
      descriptionMeta = document.createElement('meta')
      descriptionMeta.setAttribute('name', 'description')
      descriptionMeta.setAttribute('content', description)
      document.head.appendChild(descriptionMeta);
    }
  }

  router.beforeEach((to, from, next) => {
    // 做些什么，通常权限控制就在这里做哦
    /* 路由发生变化修改页面meta */
    if(to.meta.content) {
      appendMeta(to.meta.content.keywords, to.meta.content.description)
    }
    var association = store.getters.association
    var token = store.getters.token
    if(! association || !token) {
      store.dispatch('getAssociationDetail', {
        associationid: 4
      }).then(_association => {
        association = _association
        document.title = association.name
        appendMeta(`${association.name},香港中醫學會,香港中醫在綫`, association.introduce)
        setup(to, from, next)
      })
    } else {
      var title = to.meta.title || ''
      document.title = ! title ? association.name : `${title} - ${association.name}`
      setup(to, from, next)
    }
});

export default router;
